// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IsHcpIntakeAllowedRequestModel {
    static getAttributeTypeMap() {
        return IsHcpIntakeAllowedRequestModel.attributeTypeMap;
    }
}
IsHcpIntakeAllowedRequestModel.discriminator = undefined;
IsHcpIntakeAllowedRequestModel.additionalProperties = false;
IsHcpIntakeAllowedRequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "IsHcpIntakeAllowedRequestModelGender"
    },
];
//# sourceMappingURL=isHcpIntakeAllowedRequestModel.js.map